import texts from '../../texts';

export const getChangeLogText = (prevValue: string, currValue: string) => {
    if (prevValue && currValue) {
        return texts.single_change_log;
    } else if (prevValue) {
        return texts.change_wo_curr_val;
    } else if (currValue) {
        return texts.change_wo_prev_val;
    } else {
        return null;
    }
};
